import { SVGAttributes } from 'react';

import { cn } from '@/utils/twx';

interface StarsProps extends SVGAttributes<HTMLOrSVGElement> {
  /** 꽉 찬 별 개수 */
  count: number;
  /** 마지막에 반쪽 별 1개 추가 (0.5 단위 별점 — `parseRating().hasHalfStar`) */
  half?: boolean;
  /** 반쪽 별의 빈 영역 색 */
  emptyClassName?: string;
}

export const Stars = ({ count, half, emptyClassName, ...rest }: StarsProps) => {
  const arr = Array.from({ length: Math.max(0, Math.floor(count)) }, (_, i) => i);
  return (
    <div className="flex gap-0.25 items-center">
      {arr.map((_, i) => (
        <Star key={'stars' + i} {...rest} />
      ))}
      {half && <HalfStar {...rest} emptyClassName={emptyClassName} />}
    </div>
  );
};

/** 왼쪽 절반만 채워진 별 — 빈 별 위에 채운 별을 50% 로 잘라 겹친다 */
export const HalfStar = ({
  className,
  emptyClassName = 'text-cds-coolgray-30',
  ...rest
}: SVGAttributes<HTMLOrSVGElement> & { emptyClassName?: string }) => (
  <span className="relative inline-flex shrink-0">
    <Star {...rest} className={cn(className, emptyClassName)} />
    <span className="absolute inset-0 w-1/2 overflow-hidden">
      <Star {...rest} className={className} />
    </span>
  </span>
);

export const Star = (props: SVGAttributes<HTMLOrSVGElement>) => {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.05084 1.17754C8.22955 0.790104 8.78019 0.790104 8.9589 1.17754L11.099 5.81719C11.1718 5.97509 11.3214 6.08381 11.4941 6.10429L16.568 6.70588C16.9917 6.75611 17.1619 7.27981 16.8486 7.56949L13.0974 11.0385C12.9697 11.1566 12.9125 11.3325 12.9464 11.5031L13.9422 16.5145C14.0253 16.933 13.5799 17.2567 13.2076 17.0483L8.74909 14.5526C8.59735 14.4677 8.41239 14.4677 8.26065 14.5526L3.80219 17.0483C3.42988 17.2567 2.9844 16.933 3.06755 16.5145L4.06332 11.5031C4.09721 11.3325 4.04005 11.1566 3.91238 11.0385L0.161133 7.56949C-0.152117 7.27981 0.0180405 6.75611 0.441737 6.70588L5.51562 6.10429C5.6883 6.08381 5.83795 5.97509 5.91078 5.81719L8.05084 1.17754Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StarsM = (props: StarsProps) => {
  const { count, half, emptyClassName = 'text-cds-coolgray-30', ...rest } = props;

  const arr = Array.from({ length: Math.max(0, Math.floor(count)) }, (_, i) => i);
  return (
    <div className="flex gap-0.5 items-center">
      {arr.map((_, i) => (
        <StarM key={'starsm' + i} {...rest} />
      ))}
      {half && (
        <span className="relative inline-flex shrink-0">
          <StarM {...rest} className={cn(rest.className, emptyClassName)} />
          <span className="absolute inset-0 w-1/2 overflow-hidden">
            <StarM {...rest} />
          </span>
        </span>
      )}
    </div>
  );
};

export const StarM = (props: SVGAttributes<HTMLOrSVGElement>) => {
  return (
    <svg
      {...props}
      width="10"
      height="10"
      viewBox="0 -0.1 10.5 10.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.76025 0.287109C4.94021 -0.096301 5.48557 -0.096301 5.66553 0.287109L6.8335 2.77539C6.90704 2.93197 7.0562 3.03953 7.22803 3.05957L9.98291 3.38086C10.4088 3.43085 10.5785 3.95849 10.2612 4.24707L8.23682 6.08691C8.10665 6.20521 8.04782 6.38326 8.08252 6.55566L8.62158 9.22266C8.70594 9.63986 8.26408 9.96475 7.89111 9.75977L5.45361 8.41992C5.30356 8.33738 5.12125 8.33738 4.97119 8.41992L2.53467 9.75977C2.16166 9.96495 1.71885 9.63993 1.80322 9.22266L2.34229 6.55566C2.37702 6.38323 2.31915 6.20523 2.18896 6.08691L0.164551 4.24707C-0.153062 3.95842 0.0165744 3.43053 0.442871 3.38086L3.19678 3.05957C3.36868 3.03954 3.51875 2.93206 3.59229 2.77539L4.76025 0.287109Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Stars;
